module.exports = __webpack_public_path__ + "media/images/logos/twitter-20c528abbb4c7aa0cfa8e479b91d036e.svg";